import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconChecklist } from "@tabler/icons-react";
import { DatosServiciosAutorizacionProductosDef } from "./DatosServiciosAutorizacionProductosDef";

export const DatosServiciosIcon = IconChecklist;
export const DatosServiciosHelpText = '* Datos Servicios Autorización';

export class DatosServiciosAutorizacionProductos extends Entity<DatosServiciosAutorizacionProductosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DatosServiciosAutorizacionProductosDef(), parentKeys);
        this.Form = import('./DatosServiciosAutorizacionProductosForm').then((module) => module.DatosServiciosAutorizacionProductosForm);
        this.Title = "Autorización de Reportes";
        this.HelpText = DatosServiciosHelpText;
        this.Icon = DatosServiciosIcon;
    }
}